import { BASE_URL } from "../BaseUrl";
import axios from "axios";
import { headers } from "../../utils/ApiHeader";

// const token = sessionStorage.getItem("token")

// {
//   headers: { Authorization: `Bearer ${token}` },
// }
axios.interceptors.request.use(function (config) {
  const token = sessionStorage.getItem("token")
  if (token) {
    config.headers.Authorization =  `Bearer ${token}`;
  } else {
    config.headers.Authorization =  null;
  }

  return config;
});


export const getAbonneInfo_allRight = async (phoneNumber) => {
  return await axios.get(
    BASE_URL(`clientweballrights/rechercherinformations?numero=${phoneNumber}`),
    {}
  );
};

export const getAbonneInfo_secure = async (phoneNumber) => {
  return await axios.get(BASE_URL(`clientweb/rechercherinformations?numero=${phoneNumber}`), {});
};

export const activatePassword_allRight = async (values) => {
  return await axios.post(
    BASE_URL("clientweballrights/activermotdepasse"),
    values
  );
};

export const desactivePassword_secure = async (values) => {
  return await axios.post(BASE_URL("clientweb/desactivermotdepasse"), values);
};

export const modifierMotDePasse_secure = async (values) => {
  return await axios.post(BASE_URL("clientweb/modifiermotdepasse"), values);
};

export const connexionAbonneByPassword = async (values) => {
  return await axios.post(BASE_URL("clientweballrights/signin"), values);
};

export const getAbonneOTPCode = async (values) => {
  return await axios.post(BASE_URL("generercodeotp"), values);
};

export const verifieOTPCode = async (values) => {
  return await axios.post(BASE_URL("verifiercodeotp"), values);
};

export const resetAbonnePassword = async (values) => {
  return await axios.post(BASE_URL("modifiermotdepasse"), values);
};

export const getForfaitById = async (id) => {
  return await axios.get(BASE_URL(`rechercherforfaitparid/${id}`), {});
};
